<script>
    // Import animated counter component
    import Vue3Autocounter from 'vue3-autocounter';

    export default {
        components: {
            Vue3Autocounter
        },
        props: {
            data: Object,
        },
        data() {
            return {
                facetAlias: 'status_huurcontract',
                valueCurrent: 'Lopend',
                valueClosed: 'Beëindigd',
            };
        },
        computed: {
            facetsSet() {
                return this.data && this.data.queryCount && this.data.facets && this.data.facets.length;
            },
            amount() {
                if (!this.facetsSet) return 0;
                return this.data.queryCount;
            },
            amountCurrent() {
                if (!this.facetsSet) return 0;
                const facet = this.data.facets.find(f => f.alias === this.facetAlias);
                if (!facet || !facet.options || !facet.options.length) return 0;
                const option = facet.options.find(o => o.valueAlias === this.valueCurrent);
                return option ? option.filteredAmount : 0;
            },
            amountClosed() {
                if (!this.facetsSet) return 0;
                const facet = this.data.facets.find(f => f.alias === this.facetAlias);
                if (!facet || !facet.options || !facet.options.length) return 0;
                const option = facet.options.find(o => o.valueAlias === this.valueClosed);
                return option ? option.filteredAmount : 0;
            },
        },
    };
</script>

<template>
    <div class="dashboard-widget is-flex is-flex-direction-column is-justify-content-space-evenly">
        <div class="is-flex is-align-items-center is-justify-content-space-between">
            <span>{{ $store.getters.getText('dashboardWidgetDossiersamount') }}</span>
            <vue3-autocounter :endAmount="amount" separator="." duration="0.5" />
        </div>
        <div class="is-flex is-align-items-center is-justify-content-space-between">
            <span>{{ $store.getters.getText('dashboardWidgetRentalcurrent') }}</span>
            <vue3-autocounter :endAmount="amountCurrent" separator="." duration="0.5" />
        </div>
        <div class="is-flex is-align-items-center is-justify-content-space-between">
            <span>{{ $store.getters.getText('dashboardWidgetRentalclosed') }}</span>
            <vue3-autocounter :endAmount="amountClosed" separator="." duration="0.5" />
        </div>
    </div>
</template>
